<template>
    <div class="form-group col-xs-12 col-sm-6">
      <label>{{ title }} :</label>
        <VueCtkDateTimePicker v-model="content" :format="format" :label="title" inputSize="sm" no-button-now color="#70A6B2" button-color="#468b5c"
                              @input="handleInput" minute-interval="15" :min-date="minDate" :max-date="maxDate" :id="name"/>
        <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
    export default{
        name: 'vDate',
        components: {
            VueCtkDateTimePicker
        },
        props: {
            name:{
                default: ''
            },
            title: {
                default: ''
            },
            value: {
                default: ''
            },
            inputSize: {
                default: 'sm'
            },
            format: {
                default: 'YYYY-MM-DD'
            },
            minDate:{
                default: ''
            },
            maxDate:{
                default: ''
            }
        },
        data(){
            return{
                content: this.value,
                errors: {}
            }
        },
        mounted() {
            this.$emit('input', this.value === null ? '' : this.value)
            Event.listen('errors', (e) => {
                this.errors = e
            })
        },
        watch: {
          value: function(newVal, oldVal) { // watch it
            this.content = newVal
          }
        },
        methods: {
            handleInput (e) {
                this.$emit('input', this.content)
                this.$delete(this.errors, this.name)
            }
        }
    };
</script>

<style>
.time-picker-column-item.active {
 background-color: #FFFFFF!important;
}
.time-picker-column-item.active:hover {
  background-color: #FFFFFF!important;
}
</style>
